export const testimonials = [
  {
    name: "Sophie Marchand",
    role: "DRH",
    company: "Cabinet Lefèvre & Associés",
    quote:
      "Une formation IA enfin concrète. Mes équipes RH ont gagné 8 heures par semaine sur le tri et la préparation des entretiens. Pédagogie irréprochable.",
    avatar: "https://images.unsplash.com/photo-1772987292949-4b1bdc01a612?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMHBvcnRyYWl0cyUyMGhlYWRzaG90c3xlbnwwfHx8fDE3NzczOTI0NTl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Karim Benali",
    role: "Directeur Marketing",
    company: "Velia Cosmétiques",
    quote:
      "Nous avons monté toute notre stack IA en 3 jours. ROI immédiat sur la production de contenus : x4 en volume, qualité supérieure, coût divisé.",
    avatar: "https://images.unsplash.com/photo-1774813958486-4c180dcda729?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMHBvcnRyYWl0cyUyMGhlYWRzaG90c3xlbnwwfHx8fDE3NzczOTI0NTl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Élodie Rouvière",
    role: "Fondatrice",
    company: "Studio Atlas",
    quote:
      "Je redoutais le côté technique. Les formateurs YAFORMIS rendent l'IA accessible et excitante. J'ai déployé mon premier agent IA dans la semaine.",
    avatar: "https://images.pexels.com/photos/37148308/pexels-photo-37148308.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Thomas Vidal",
    role: "Responsable Innovation",
    company: "Groupe Pléiade",
    quote:
      "Formation Agents IA exceptionnelle. Niveau technique élevé, formateurs au top, projet final déployé en production. Recommandé sans hésiter.",
    avatar: "https://images.unsplash.com/photo-1772987292949-4b1bdc01a612?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMHBvcnRyYWl0cyUyMGhlYWRzaG90c3xlbnwwfHx8fDE3NzczOTI0NTl8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const partnerLogos = [
  "Atlas Studio", "Velia", "Pléiade", "Lefèvre & Co", "NovaTech",
  "Groupe Helios", "Maison Vidal", "Solys Conseil", "Karim&Co", "Édifice"
];
